import React, { useEffect, useState } from "react";
import { Box, Button, Checkbox, CircularProgress, FormControl, Input, MenuItem, Modal, Select, Stack, TextField, Typography, InputLabel } from "@mui/material";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
  } from "@mui/material";
import Div from "@jumbo/shared/Div";
import TableOA from "app/pages/OA/TableOA";
import DeleteIcon from "@mui/icons-material/Delete";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import PublishIcon from "@mui/icons-material/Publish";
import { toast } from "react-toastify";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { axios_tenant } from "../../../axios";
import moment from "moment";
import DialogueBox from "app/components/DialogueBox";
import { v4 as uuidV4 } from "uuid";
import { set } from "lodash";

const ReceivedOA = () => {
    const menus = ["Received", "Prepared", "Responded"];
    const [checked, setChecked] = useState({ received: true, prepared: true });
    const { received, prepared } = checked;
    const [appNo, setAppNo] = useState("");
    const [attorneyRegNo, setAttorneyRegNo] = useState("");
    const [openClaim, setOpenClaim] = useState(false);
    const [openAdd, setOpenAdd] = useState(false);
    const [search, setSearch] = useState("");
    const [dropdownValue, setDropdownValue] = useState("oa");
    const [startDate, setStartDate] = useState(moment());
    const [endDate, setEndDate] = useState(moment());
    const [OaData, setOaData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [getDataLoading, setGetDataLoading] = useState(false);
    const [downloadLoading, setDownloadLoading] = useState(false);
    const [claimsLoading, setClaimsLoading] = useState(false);
    const [clickDownload, setClickDownload] = useState(false);
    const [oaFiles, setOaFiles] = useState({});
    const [clickUpload, setClickUpload] = useState(false);
    const [showDownload, setShowDownload] = useState(false);
    const [showDelete, setShowDelete] = useState(false);
    const [deleteLoading, setDeleteLoading] = useState(false);
    const [clickDelete, setClickDelete] = useState(false);
    const [confirmDelete, setConfirmDelete] = useState(false);
    const [templateNames, setTemplateNames] = useState([]);
    const [selectedTemplate, setSelectedTemplate] = useState("");
    const [selectedRows, setSelectedRows] = useState({});
    const [pollingStatus, setPollingStatus] = useState(null);
    const [trackingId, setTrackingId] = useState(null);
    const [draftBuffer, setDraftBuffer] = useState(null);

    useEffect(() => {
        getOaData();
    }, []);

    const getOaData = () => {
        setGetDataLoading(true);
        axios_tenant
            .get("/oa/data")
            .then(res => {
                setGetDataLoading(false);
                setOaData(res?.data?.results || []);
                setTemplateNames(res.data.templateNames);
            })
            .catch(err => {
                setGetDataLoading(false);
            });
    };

    const handleSearch = e => {
        setSearch(e.target.value);
    };

    const handleCheck = e => {
        setSearch("");
        setChecked({ ...checked, [e.target.id]: e.target.checked });
    };

    const handleClickUpload = () => {
        setOpenAdd(false);
        setOpenClaim(!openClaim);
        setClickUpload(true);
    };
    const [openConfirmModal, setOpenConfirmModal] = useState(false);
    const handleUpload = async () => {
        setOpenClaim(false);
        
        if (!oaFiles.claimsFile) {
        setOpenConfirmModal(true); // Show confirmation modal
        return;
        }
        
        // If claimsFile exists, proceed directly
        await proceedWithUpload();
    };

    const handleConfirmProceed = () => {
        setOpenConfirmModal(false);
        proceedWithUpload();
      };
    
      const handleCancelProceed = () => {
        setOpenConfirmModal(false);
      };

    const matchFileNames = (pdfFileName, docxFileName) => {
        const pdfFileParts = pdfFileName.split("_");
        const docxFileParts = docxFileName.split("_");
        if (pdfFileParts.length < 4 || docxFileParts.length < 4) {
            toast.error("Invalid file name format");
            return false;
        }
        const pdfFileFirstThreeParts = pdfFileParts.slice(0, 3).join("_");
        const docxFileFirstThreeParts = docxFileParts.slice(0, 3).join("_");
        const pdfFileLastPart = pdfFileParts[3];
        const docxFileLastPart = docxFileParts[3];
        if (pdfFileFirstThreeParts !== docxFileFirstThreeParts) {
            toast.error("Pdf and Docx file names should be same");
            return false;
        }
        // get first 4 character of last part and compare case insenstive if they are same
        if( pdfFileLastPart.substring(0, 4).toLowerCase() !== docxFileLastPart.substring(0, 4).toLowerCase()) {
            toast.error("Rejection type should be same in both file names");
            return false;
        }
        
        return true;
    }

    const proceedWithUpload = async () => {   
        setLoading(true);
        setClaimsLoading(true);
        const formData = new FormData();
        const { pdfFile, docxFile, claimsFile } = oaFiles;
        // make sure file name of pdf and docx file (after removing extension ) is same
        if (pdfFile && docxFile) {
            const pdfFileName = pdfFile.name.split(".")[0];
            const docxFileName = docxFile.name.split(".")[0];
            const filesMatch = matchFileNames(pdfFileName, docxFileName);
            if (!filesMatch) {
                setLoading(false);
                setClaimsLoading(false);
                return;
            }
        }

        formData.append("attorneyRegNo", attorneyRegNo);
        formData.append("files", pdfFile);
        formData.append("files", docxFile);
        if (claimsFile) { // Only append claimsFile if it exists
            formData.append("files", claimsFile);
        }
        formData.append("templateFile", selectedTemplate);
        const trackingId = uuidV4();
        formData.append("trackingId", trackingId);
        setTrackingId(trackingId);

        try {
            const response = await axios_tenant.post("/oa/generateResponse", formData);
            setChecked({ ...checked, prepared: true, received: false });
            const successMessage = response.data.missedApplicationDetails
                ? `Successfully generated response document.${response.data.missedApplicationDetails}`
                : "Successfully generated response document";
            toast.success(successMessage);
            await getOaData();
        } catch (e) {
        } finally {
            setLoading(false);
            setClaimsLoading(false);
            setOaFiles({});
            setAttorneyRegNo("");
            setSelectedTemplate("");
            setPollingStatus(null); // Clear polling status
            setTrackingId(null); // Clear tracking ID
            setDraftBuffer(null); // Clear draft buffer
        }
    };

    const pollOaDraftStatus = async () => {
        setPollingStatus(null);
        setDraftBuffer(null);
        if (!trackingId) return;
        await new Promise(resolve => setTimeout(resolve, 30000)); // Wait for 1 minute before polling
        const interval = setInterval(async () => {
            try {
                const response = await axios_tenant.get(`/oa/status/oa/${trackingId}`, {
                    headers: {
                        'Content-Type': 'application/json',
                    }
                });

                const status = response.data.status;
                const draftBuffer = response.data.draft;
                setPollingStatus(status);
                setDraftBuffer(draftBuffer);

                if (status === 'ready' || status === 'failed') {
                    clearInterval(interval);
                }
            } catch (error) {
                console.error("Error polling OA draft status:", error);
                clearInterval(interval);
            }
        }, 10000); // Poll every 10 seconds

        return () => clearInterval(interval);
    };

    useEffect(() => {
        if (trackingId) {
            pollOaDraftStatus();
        }
    }, [trackingId]);

    const handleDownloadDraft = () => {
        if (!draftBuffer) {
            toast.error("No draft available for download.");
            return;
        }
    
        // Convert the base64 string to a Blob
        const byteCharacters = atob(draftBuffer);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' });
    
        // Create a URL for the Blob
        const url = window.URL.createObjectURL(blob);
    
        // Create a temporary anchor element to trigger the download
        const a = document.createElement('a');
        a.href = url;
        a.download = `OA_shell_draft.docx`; // You can customize the filename here
        document.body.appendChild(a);
        a.click();
    
        // Clean up
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
    
        toast.success("Draft downloaded successfully.");
    };
    useEffect(() => {
        if (draftBuffer) {
            handleDownloadDraft();
        }
    }, [draftBuffer]);
    const handleFileChange = e => {
        setOaFiles({ ...oaFiles, [e.target.id]: e.target.files[0] });
    };

    const handleDropdown = e => {
        setSearch("");
        setStartDate(moment());
        setEndDate(moment());
        setDropdownValue(e.target.value);
    };

    const handleTemplateDropdown = e => {
        setSelectedTemplate(e.target.value);
    };

    const handleClickAdd = () => {
        setOpenClaim(false);
        setOpenAdd(!openAdd);
    };

    const handleAddSubmit = () => {
        setOpenAdd(false);
        setLoading(true);
        axios_tenant
            .post(`/oa/scrap?applicationNos=${applicationNo}`)
            .then(res => {
                setLoading(false);
                getOaData();
                toast.info(`Application status : ${res.data}`);
            })
            .catch(err => {
                setLoading(false);
            });
    };

    const handleDownload = selectedIds => {
        setClickDownload(false);

        if (selectedIds.length > 0) {
            setDownloadLoading(true);

            axios_tenant
                .get(`/oa/zip-download`, {
                    params: {
                        selectedIdString: JSON.stringify(selectedIds)
                    },
                    responseType: "arraybuffer"
                })
                .then(res => {
                    setDownloadLoading(false);
                    const blob = new Blob([res.data], { type: "application/zip" });
                    const url = window.URL.createObjectURL(blob);

                    const a = document.createElement("a");
                    a.style.display = "none";
                    a.href = url;
                    a.download = res.headers['content-disposition']?.split('filename=')[1];
                    document.body.appendChild(a);

                    a.click();

                    toast.success("Package zip file downloaded");
                    window.URL.revokeObjectURL(url);
                    document.body.removeChild(a);
                })
                .catch(err => {
                    setDownloadLoading(false);
                    toast.error("Download failed");
                });
        }
    };

    const handleDelete = selectedIds => {
        setClickDelete(false);
        setConfirmDelete(false);

        if (selectedIds.length > 0) {
            setDeleteLoading(true);

            axios_tenant
                .delete(`/oa/delete`, {
                    params: {
                        selectedIdString: JSON.stringify(selectedIds)
                    }
                })
                .then(res => {
                    setDeleteLoading(false);
                    getOaData();
                    setSelectedRows({});
                    toast.success("Selected records deleted successfully");
                })
                .catch(err => {
                    setSelectedRows({});
                    setDeleteLoading(false);
                    setConfirmDelete(false);
                    toast.error("Deleting records failed");
                });
        }
    };

    const filteredOAData = OaData.filter(item => {
        if (dropdownValue === "oa") {
            const itemValues = Object.values(item)?.map(value => {
                return String(value).toLowerCase();
            });

            const searchResult = itemValues.some(value => value.includes(search.toLowerCase()));

            if (received && item.status === "Received" && searchResult) return true;
            if (prepared && item.status === "Prepared" && searchResult) return true;
        } else if (dropdownValue === "mailRoomDate" || dropdownValue === "preparedDate") {
            const [day, month, year] = dropdownValue === "mailRoomDate" ? item?.mailRoomDate?.split("T")[0]?.split("/") || [] : item?.preparedDate?.split("T")[0]?.split("/") || [];
            const searchedDate = new Date(`${year}-${month}-${day}`);
            const dateResult = searchedDate >= startDate?._d && searchedDate <= endDate?._d;
            if (received && item.status === "Received" && dateResult) return true;
            if (prepared && item.status === "Prepared" && dateResult) return true;
        } else {
            if (received && item.status === "Received" && item[dropdownValue]?.toLowerCase().includes(search.toLowerCase())) return true;
            if (prepared && item.status === "Prepared" && item[dropdownValue]?.toLowerCase().includes(search.toLowerCase())) return true;
        }

        return false;
    });

    const style = {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: 400,
        bgcolor: "background.paper",
        border: "2px solid #000",
        boxShadow: 24,
        p: 4
    };

    return (
        <>
            <Stack direction="row" alignItems="center" spacing={5}>
                <Box display="flex" alignItems="center">
                    <Select value={dropdownValue} onChange={e => handleDropdown(e)} variant="outlined" sx={{ width: "45%", borderRadius: "16px 0px 0px 16px", "& .MuiInputBase-input": { height: 20 } }}>
                        <MenuItem value={"oa"}>All OA's</MenuItem>
                        <MenuItem value={"applicationNo"}>App No.</MenuItem>
                        <MenuItem value={"rejectionType"}>Rejection Type</MenuItem>
                        <MenuItem value={"mailRoomDate"}>Mail Room Date</MenuItem>
                        {prepared && <MenuItem value={"preparedDate"}>Prepared Date</MenuItem>}
                    </Select>

                    {dropdownValue === "mailRoomDate" || dropdownValue === "preparedDate" ? (
                        <LocalizationProvider dateAdapter={AdapterMoment}>
                            <DatePicker
                                label="Start date"
                                value={startDate}
                                onChange={newValue => {
                                    setStartDate(newValue);
                                }}
                                renderInput={params => <TextField {...params} />}
                                inputFormat="DD/MM/YYYY"
                            />
                            <DatePicker
                                label="End date"
                                value={endDate}
                                onChange={newValue => {
                                    setEndDate(newValue);
                                }}
                                renderInput={params => <TextField {...params} />}
                                inputFormat="DD/MM/YYYY"
                            />
                        </LocalizationProvider>
                    ) : (
                        <TextField variant="outlined" label="Search" value={search} onChange={handleSearch} sx={{ width: 300, borderRadius: "0px 24px 24px 0px", "& .MuiInputBase-input": { height: 20 } }} />
                    )}
                </Box>
                <Box sx={{ flexGrow: 1 }} />

                {downloadLoading ? (
                    <span>
                        <CircularProgress sx={{ color: "blue" }} /> Downloading...
                    </span>
                ) : (
                    <span style={showDownload ? { cursor: "pointer" } : { cursor: "not-allowed", color: "grey", opacity: 0.5 }} onClick={showDownload ? () => setClickDownload(true) : () => {}}>
                            <FileDownloadIcon fontSize="large" /> Download
                        </span>
                )}

                {deleteLoading ? (
                    <span>
                        <CircularProgress sx={{ color: "blue" }} /> Deleting selected records...
                    </span>
                ) : (
                    <span style={showDelete ? { cursor: "pointer" } : { cursor: "not-allowed", color: "grey", opacity: 0.5 }} onClick={showDelete ? () => setClickDelete(true) : () => {}}>
                            <DeleteIcon fontSize="large" /> Delete
                        </span>
                )}

                <DialogueBox clickDelete={clickDelete} setClickDelete={setClickDelete} setConfirmDelete={setConfirmDelete} />

            </Stack>

            <Box sx={{ display: "flex", mt: "1%", alignItems: "center" }}>

                <Box sx={{ flexGrow: 1 }} />

                <Button type="submit" variant="contained" color="primary" onClick={handleClickUpload} disabled={loading}>
                    {loading ? (
                        <>
                            <span>
                                {pollingStatus === 'processing' ? "OA Shell Draft is generating..." : pollingStatus === 'ready' ? "Draft is ready for download. Preparing the package..." : "Generating response document..."}
                            </span>
                            {/* {pollingStatus === 'ready' ?
                                (
                                    <span>
                                        <FileDownloadIcon fontSize="large" onClick={handleDownloadDraft} />
                                    </span>
                                ): null
                            } */}
                            
                            <CircularProgress sx={{ color: "blue" }} />
                        </>
                    ) : (
                        <span>Upload Files</span>
                    )}
                </Button>
                {(
                    <>
                        {pollingStatus === 'ready' && loading ?
                            (
                                <span>
                                    <FileDownloadIcon fontSize="large" onClick={handleDownloadDraft} sx={{cursor:"pointer"}}/>
                                </span>
                            ): null
                        }
                    </>
                )}
                <Modal
                    open={openClaim}
                    onClose={() => {
                        setOpenClaim(false), setOaFiles({});
                    }}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Div sx={style}>
                        <Typography id="modal-modal-title" variant="h4" component="h2">
                            Upload Office Action Files
                        </Typography>
                        <br></br>
                        <Typography id="modal-modal-title" variant="h6" component="h6">
                            <FormControl fullWidth>
                                {/* <TextField sx={{ mb: 1 }} id="appNo" label="Application No" value={appNo} disabled />
                                <br></br> */}
                                  Rejection Pdf File:
                                <input id="pdfFile" type="file" onChange={handleFileChange} accept=".pdf"/>
                                <br></br>
                                Rejection Docx file:
                                <input id="docxFile" type="file" onChange={handleFileChange} accept=".docx,.doc"/>
                                <br></br>
                                Claims File:
                                <input id="claimsFile" type="file" onChange={handleFileChange} accept=".docx,.doc"/>
                                <br></br>
                                <TextField sx={{ mb: 1 }} label="Attorney Registration No." value={attorneyRegNo} onChange={e => setAttorneyRegNo(e.target.value)} />
        
                                    <Select value={selectedTemplate} onChange={e => handleTemplateDropdown(e)} variant="outlined" displayEmpty renderValue={selectedTemplate !== "" ? undefined : () => "Select Template"}>
                                        {templateNames?.map((item, index) => (
                                            <MenuItem key={index} value={item}>
                                                {(item.split("/")[2]).split(".")[0]}
                                            </MenuItem>
                                        ))}
                                    </Select>
                            </FormControl>
                        </Typography>

                        <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                            <Button type="submit" variant="contained" color="primary" onClick={handleUpload} disabled={!(selectedTemplate && Object.values(oaFiles).length >= 2)}>
                                Submit
                            </Button>
                        </Typography>
                    </Div>
                </Modal>
            </Box>
            
            <div style={{fontStyle: "italic",display:"flex"}}> {`Total selected items : ${Object.keys(selectedRows).filter((key) => selectedRows[key])?.length || 0}`}</div>
            <Box sx={{ mt: "1%" }}>{getDataLoading ? <Typography variant="h4">Loading...</Typography> :
                 <TableOA 
                 OAdata={filteredOAData} 
                 prepared={prepared} 
                 loading={loading} 
                 handleDownload={handleDownload} 
                 clickDownload={clickDownload} 
                 clickUpload={clickUpload} 
                 setAppNo={setAppNo} 
                 setShowDelete={setShowDelete} 
                 setShowDownload={setShowDownload}
                 confirmDelete={confirmDelete} 
                 handleDelete={handleDelete} 
                 checked={selectedRows}
                 setChecked={setSelectedRows}
                 />}</Box>

            <Dialog
                open={openConfirmModal}
                onClose={handleCancelProceed}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">Proceed without Claims File?</DialogTitle>
                <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    You haven't uploaded a claims file. Are you sure you want to proceed without it?
                </DialogContentText>
                </DialogContent>
                <DialogActions>
                <Button onClick={handleCancelProceed} color="primary">
                    Cancel
                </Button>
                <Button onClick={handleConfirmProceed} color="primary" autoFocus>
                    Proceed
                </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default ReceivedOA;
